// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3791":"02132155","6978":"8b4dc568"}[chunkId] + ".chunk.css";
};